'use es6';

import { Map as ImmutableMap } from 'immutable';
import { TOGGLE_FOLDER_SELECTION, TOGGLE_ROW_SELECTION, SET_SEARCH_QUERY, SET_SELECTED_FOLDER, ADD_TEMP_RESULT, REMOVE_RESULT, REMOVE_RESULTS, UPDATE_RESULT } from 'SalesContentIndexUI/data/constants/ActionTypes';
const initialState = {
  selectedFolders: ImmutableMap(),
  selectedRows: ImmutableMap()
};
const updateSelection = (selectedResults, searchResult) => {
  const {
    contentId
  } = searchResult;
  return selectedResults.has(contentId) ? selectedResults.remove(contentId) : selectedResults.set(contentId, searchResult);
};
export default ((state = initialState, action) => {
  switch (action.type) {
    case TOGGLE_FOLDER_SELECTION:
      {
        const {
          selectedFolders
        } = state;
        const searchResult = action.payload;
        return Object.assign({}, state, {
          selectedFolders: updateSelection(selectedFolders, searchResult)
        });
      }
    case TOGGLE_ROW_SELECTION:
      {
        const {
          selectedRows
        } = state;
        const searchResult = action.payload;
        return Object.assign({}, state, {
          selectedRows: updateSelection(selectedRows, searchResult)
        });
      }
    case UPDATE_RESULT:
      return {
        selectedFolders: state.selectedFolders.map(folderRecord => folderRecord.id === action.payload.id ? action.payload : folderRecord),
        selectedRows: state.selectedRows.map(contentRecord => contentRecord.id === action.payload.id ? action.payload : contentRecord)
      };
    case ADD_TEMP_RESULT:
    case REMOVE_RESULT:
    case REMOVE_RESULTS:
    case SET_SEARCH_QUERY:
    case SET_SELECTED_FOLDER:
      return initialState;
    default:
      return state;
  }
});